import * as Http from "../../../http";
export default {
  /**
   * 获取物流公司
   * @param params
   * @returns {Promise<* | {errorCode: *, errorMsg: *, isSuccess: boolean}>}
   */
  getPddLogisticsCompanyList(params) {
    return Http.post('template/getPddLogisticsCompanyList',params);
  },
  /**
   * 切换店铺
   * @param ownerId
   * @returns {Promise<* | {errorCode: *, errorMsg: *, isSuccess: boolean}>}
   */
  changeShop(ownerId) {
    return Http.post('pdd/auth/changeShop', {ownerId});
  },
  /**
   * 获取店铺
   * @returns {Promise<* | {errorCode: *, errorMsg: *, isSuccess: boolean}>}
   */
  getPddShopList() {
    return Http.post('print/getPddShopList');
  },
  /**
   * 获取物流轨迹信息
   * @param params
   * @returns {Promise<* | {errorCode: *, errorMsg: *, isSuccess: boolean}>}
   */
  getLogisticsTraceInfo(params) {
    return Http.post('pdd/order/getLogisticsTraceInfo', params);
  },
  /**
   * 订单解密
   * @param method
   * @param params
   * @returns {Promise<* | {errorCode: *, errorMsg: *, isSuccess: boolean}>}
   */
  decryptPddOrderInfo(method, params) {
    return Http.post(`pdd/control/decrypt/v1/${method}`, params);
  },
  /**
   * 获取通知信息
   * @param params
   * @returns {Promise<* | {errorCode: *, errorMsg: *, isSuccess: boolean}>}
   */
  getNoticeByType(params) {
    return Http.post('notice/message/getNoticeByType', params);
  },
  /**
   * 获取登录信息
   * @returns {Promise<* | {errorCode: *, errorMsg: *, isSuccess: boolean}>}
   */
  getSelectedLoginId() {
    return Http.post('print/getSelectedLoginId');
  },
  /**
   * 根据ownerId获取店铺信息
   * @param ownerId
   * @returns {Promise<* | {errorCode: *, errorMsg: *, isSuccess: boolean}>}
   */
  getPddShopByOwnerId(ownerId) {
    return Http.post('print/getPddShop', { ownerId });
  },
  /**
   * 获取授权链接
   * @returns {Promise<* | {errorCode: *, errorMsg: *, isSuccess: boolean}>}
   */
  getAuthUrl() {
    return Http.post('pdd/auth/getAuthUrl');
  },
  /**
   * 获取模板打印项 10-发货单 11-拣货单
   * @param type
   * @returns {Promise<* | {errorCode: *, errorMsg: *, isSuccess: boolean}>}
   */
  getPrintItems(type){
    return Http.post('template/getPrintItems', { type });
  },
}



// WEBPACK FOOTER //
// ./src/utils/api/v2/common/index.js